import { useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import TextArea from 'modules/core/components/TextArea'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onReject: (reason: string) => void
  setShowRejectedModal: (value: boolean) => void
  rejecting: boolean
}
export const RejectModal = ({ onReject, setShowRejectedModal }: Props) => {
  const [reason, setReason] = useState<string>('')

  const onRejectFunction = (reason: string) => {
    onReject(reason)
  }

  const onCancelFunction = () => {
    setShowRejectedModal(false)
    track(trackingEvents.training.trainingRequest.rejectTrainingRequest.cancel)
  }

  return (
    <Modal
      title={i18n.t('trainings.training_requests.my_requests.detail.reject_modal.title')}
      illustration="comment"
      onClose={() => setShowRejectedModal(false)}
      onSubmit={() => onReject(reason)}
      footer={
        <Box flexDirection="row" gap="s8">
          <Button onClick={onCancelFunction} type="secondary">
            {i18n.t('trainings.training_requests.my_requests.detail.reject_modal.cancel')}
          </Button>
          <Button onClick={() => onRejectFunction(reason)}>
            {i18n.t('trainings.training_requests.my_requests.detail.reject_modal.reject')}
          </Button>
        </Box>
      }
    >
      <TextArea
        value={reason}
        label={i18n.t('trainings.training_requests.my_requests.detail.reject_modal.comments_label')}
        onChange={(value) => setReason(value)}
      />
    </Modal>
  )
}
